import { Typography } from "@mui/material";
import moment from "moment";

import { TDateISO } from "api/common/types/datetime.types";

import SidebarSection from "../../SidebarSection";

const CertificationDateSection = ({
  certification_date,
}: {
  certification_date: TDateISO;
}) => {
  const formattedCertificationDate = certification_date
    ? moment.utc(certification_date).format("MM/DD/YYYY")
    : "No Certification Date";

  return (
    <SidebarSection title="Certification Date:">
      <Typography variant="body1">{formattedCertificationDate}</Typography>
    </SidebarSection>
  );
};

export default CertificationDateSection;
